// Automatically recovers from Vite chunk load failures caused by deploy/version skew.
// If a dynamically imported chunk fails to load, the app fetches the current build ID
// and reloads the page once per build to force the browser onto the latest assets.

const RELOAD_KEY = 'vite_chunk_reload_build';

async function getBuildId() {
  const r = await fetch('/vite-build.txt', { cache: 'no-store' });
  if (!r.ok) return null;
  const txt = (await r.text()).trim() || null;
  return txt;
}

function isChunkLoadError(err) {
  const msg = String(err?.message || err || '');
  const match = msg.includes('Failed to fetch dynamically imported module');
  return match;
}

async function recoverFromChunkError() {
  const buildId = await getBuildId();
  const last = sessionStorage.getItem(RELOAD_KEY);

  if (buildId && last === buildId) {
    return;
  }

  if (buildId) {
    sessionStorage.setItem(RELOAD_KEY, buildId);
  }

  location.replace(location.href);
}

window.addEventListener('unhandledrejection', (e) => {
  if (isChunkLoadError(e?.reason)) {
    recoverFromChunkError();
  }
})

window.addEventListener('error', (e) => {
  if (isChunkLoadError(e?.error || e?.message)) {
    recoverFromChunkError();
  }
})
